module.exports = __webpack_public_path__ + "img/LT.4ae6247d.svg";